// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","sub_heading":"styles_sub_heading__g5B13"};